import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./CrmReportFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useState, useEffect } from "react";
import CrmReportFormStepOne from "./CrmReportFormStepOne";

// Move the static initial values outside the component to avoid unnecessary re-renders
const initialResults = [
  { type: "EMAIL", result: 0 },
  { type: "PHONE", result: 0 },
  { type: "MEET", result: 0 },
  { type: "MEET_ONLINE", result: 0 },
  // { type: "VISIT_BANK", result: 0 },
];

const initialOfferResults = [
  { type: "WIN", result: 0 },
  { type: "LOSS", result: 0 },
];

const CrmReportForm = (props) => {
  const theme = useTheme();
  const [results, setResults] = useState(initialResults);
  const [offerResults, setOfferResults] = useState(initialOfferResults);

  const { step, setStep, initialValues: _initialValues, isSubmit } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    // Fetch initial values if necessary
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props, setResults, setOfferResults)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => (
        <form
          id={props.formName}
          onSubmit={formProps.handleSubmit}
          className="CrmFormReport"
        >
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={step}
            onChangeIndex={(index) => setStep(index)}
          >
            <CrmReportFormStepOne
              {...formProps}
              {...props}
              results={results}
              offerResults={offerResults}
            />
          </SwipeableViews>
        </form>
      )}
    </Form>
  );
};

export default CrmReportForm;
